import { render, staticRenderFns } from "./testBoard.vue?vue&type=template&id=76b7ef8a&scoped=true&"
import script from "./testBoard.vue?vue&type=script&lang=js&"
export * from "./testBoard.vue?vue&type=script&lang=js&"
import style0 from "./testBoard.vue?vue&type=style&index=0&id=76b7ef8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b7ef8a",
  null
  
)

export default component.exports